import { createGtm } from '@gtm-support/vue-gtm';

export default defineNuxtPlugin((nuxtApp) => {
    const { activeSite } = useMultisite();

    if (!activeSite.value.gtmId) {
        return;
    }

    nuxtApp.vueApp.use(
        createGtm({
            id: activeSite.value.gtmId,
            defer: false, // Script can be set to `defer` to speed up page load at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible). Defaults to false, so the script is loaded `async` by default
            compatibility: false, // Will add `async` and `defer` to the script tag to not block requests for old browsers that do not support `async`
            debug: nuxtApp.$config.public.appEnv === 'development', // Whether or not display console logs debugs (optional)
            vueRouter: useRouter(), // Pass the router instance to automatically sync with router (optional)
            trackOnNextTick: true, // Whether or not call trackView in Vue.nextTick
        }),
    );
});
